var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3238.7 1543.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#f47458;}.cls-3{fill:#eab054;}.cls-4{fill:#5184ce;}.cls-5{fill:#f47458;}.cls-6{fill:#91342a;}.cls-7{fill:#fae0b2;}.cls-8{fill:#4e9b87;}.cls-9{fill:#f0937f;}.cls-10{fill:#b75742;}.cls-11{opacity:.7;}.cls-11,.cls-12{fill:#c5ddf9;}.cls-12{opacity:.6;}.cls-13{fill:#9e9da2;}.cls-14{fill:#feb546;}.cls-14,.cls-15,.cls-16{opacity:.5;}.cls-14,.cls-17{mix-blend-mode:multiply;}.cls-18{fill:#3c8f7c;}.cls-19{fill:#f48c7f;}.cls-20{fill:#263d60;}.cls-21{fill:#d8d9dd;}.cls-15,.cls-22,.cls-23{fill:#fff;}.cls-22{opacity:.2;}.cls-24{fill:#184655;}.cls-25{isolation:isolate;}.cls-26{fill:#cf283c;}.cls-27{fill:#f8d18b;}.cls-28{fill:#13375b;}.cls-29{fill:#13375b;}.cls-30{fill:#96d9c9;}.cls-31{fill:#f8a492;}.cls-16{fill:#b0cff4;}.cls-32{fill:#9bc1f9;}.cls-33{fill:#eafcfc;}.cls-34{fill:#184655;}.cls-35{fill:#f7a491;}.cls-36{fill:#f7a491;}.cls-37{fill:#b8d6f9;}.cls-38{fill:#50bfa5;}.cls-2{opacity:.3;}.cls-39{fill:#1a1a1a;}.cls-40{fill:#86b1f2;}.cls-41{fill:#355389;}.cls-42{fill:#f7cc7f;}.cls-43{fill:#183658;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M277.55,1529.45h2832.11c234.75-136.24,113.94-546.2-82.13-629.3-211.06-89.46,124.09-398.84-201.04-499.26-212.28-65.57-499.98,7.68-640.51-133.47-165.11-165.84-439.4-367.7-950.24-210.84-393.99,120.98-180,354.22-824.72,424.44-331.52,36.11-267.46,345.05-236.55,408.89,26.92,55.6,205.04,143.8-42.5,265.26-362.99,178.1,137.01,371.02,145.57,374.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1056.82,1071.5s290.16-367.57,462.73-366.39c172.57,1.18,360.56,242.11,606.14,447.88,275.21,230.59-84.15,240.27-104.89,242.17-20.74,1.9-736.3-23.38-748.23-35.82-11.93-12.45-202.99-171.88-202.99-171.88l-12.76-115.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2545.65,
    y: 946.64,
    width: 12.26,
    height: 135.92,
    transform: "translate(5103.57 2029.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "2551.78 682.96 2591.81 1006.43 2511.76 1006.43 2551.78 682.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "2577.29 889.11 2520.22 938.05 2522.41 920.32 2575.52 874.78 2577.29 889.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "2568.52 818.21 2533.57 830.15 2535.21 816.88 2567.01 806 2568.52 818.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "875.73 843.24 911.47 1132.03 840 1132.03 875.73 843.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "938.68 885.65 965.9 1105.59 911.47 1105.59 938.68 885.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "993.11 951.15 1020.33 1171.09 965.9 1171.09 993.11 951.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "808.88 907.73 844.61 1196.52 773.14 1196.52 808.88 907.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M943.99,997.55c309.97,51.58,775.08,515.08,1129.33,515.08s430.53-110.86,563.38-87.42c132.84,23.44,311.18,87.42,311.18,87.42l-2632.49,7.78s318.62-574.44,628.59-522.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "2066.02 862.46 2101.76 1151.25 2030.29 1151.25 2066.02 862.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1936.69 1064.88 1963.9 1284.83 1909.47 1284.83 1936.69 1064.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1999.17 926.95 2034.9 1215.74 1963.43 1215.74 1999.17 926.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2998.81,1196.09l.49-25.42c0-18.85-14.39-34.14-32.14-34.14h0c-44.73,0-80.98,38.52-80.98,86.03v34.74c0,15.22-8.08,28.43-19.93,35.06-10.76,6.02-17.34,18.05-17.34,30.98v18.31c0,19.83,8.76,38.33,23.32,50.74,8.51,7.26,13.96,18.4,13.96,30.9v25.93c0,28.67,21.88,51.9,48.86,51.9h15.4c26.99,0,48.86-23.24,48.86-51.9h0c-4.43-36.21,6.31-57.11,18.69-69.05,18.21-17.56,28.87-42.26,28.87-68.39v-3.66c0-27.58-11.98-53.4-32-70.95-8.84-7.75-16.05-20.41-16.05-41.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M2348.98,997.55c-309.97,51.58-775.08,515.08-1129.33,515.08s-430.53-110.86-563.38-87.42c-132.85,23.44-311.19,87.42-311.19,87.42l2632.49,7.78s-318.62-574.44-628.59-522.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M315.4,1520.41s339.85-295.21,778.06-313.34c147.15-6.09,749.68,116,1257.07,211.92,21.33,4.03,553.1,102.26,625.5,105.18l-2660.62-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1493.66,362.5c-5.16-22.46-25.26-39.22-49.29-39.22-4.41,0-8.69.57-12.77,1.63-11.86-25.36-37.6-42.94-67.45-42.94-7.72,0-15.16,1.17-22.16,3.35-16.07-26.61-45.26-44.4-78.61-44.4-39.68,0-73.47,25.18-86.28,60.43-9.06-5.05-19.5-7.94-30.61-7.94-34.78,0-62.97,28.19-62.97,62.97,0,2.06.11,4.1.3,6.11h409.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2052.37,755.36c2.49-10.82,12.17-18.89,23.74-18.89,2.12,0,4.18.27,6.15.78,5.71-12.21,18.11-20.68,32.48-20.68,3.72,0,7.3.57,10.67,1.62,7.74-12.81,21.79-21.38,37.85-21.38,19.11,0,35.38,12.13,41.55,29.1,4.36-2.43,9.39-3.83,14.74-3.83,16.75,0,30.32,13.58,30.32,30.32,0,.99-.05,1.97-.14,2.94h-197.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1705.86,614.65c-3.05-13.29-14.95-23.21-29.17-23.21-2.61,0-5.14.34-7.56.96-7.02-15.01-22.25-25.41-39.91-25.41-4.57,0-8.97.69-13.11,1.99-9.51-15.75-26.78-26.27-46.52-26.27-23.48,0-43.48,14.9-51.06,35.77-5.36-2.99-11.54-4.7-18.12-4.7-20.58,0-37.27,16.68-37.27,37.27,0,1.22.06,2.43.18,3.62h242.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2178.33,458.5c-4.12-17.95-20.19-31.35-39.4-31.35-3.53,0-6.95.45-10.21,1.3-9.48-20.27-30.05-34.31-53.9-34.31-6.17,0-12.11.94-17.71,2.68-12.84-21.26-36.17-35.48-62.83-35.48-31.71,0-58.72,20.13-68.95,48.3-7.24-4.04-15.58-6.35-24.47-6.35-27.79,0-50.33,22.53-50.33,50.33,0,1.65.09,3.28.24,4.88h327.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M856.98,677.77c2.06-8.95,10.07-15.63,19.64-15.63,1.76,0,3.46.23,5.09.65,4.73-10.1,14.98-17.11,26.87-17.11,3.07,0,6.04.47,8.83,1.34,6.4-10.6,18.03-17.69,31.32-17.69,15.81,0,29.27,10.03,34.37,24.08,3.61-2.01,7.77-3.16,12.2-3.16,13.86,0,25.09,11.23,25.09,25.09,0,.82-.04,1.63-.12,2.43h-163.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 912.3,
    y: 747.88,
    width: 6.04,
    height: 20.54,
    transform: "translate(1673.46 -157.17) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M844.5,794.17h143.51c9.48,0,17.17,7.69,17.17,17.17v29.88c0,9.48-7.69,17.17-17.17,17.17h-143.51c-9.47,0-17.17-7.69-17.17-17.17v-29.88c0-9.48,7.69-17.17,17.17-17.17Z",
    transform: "translate(1742.53 -89.97) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M916.25,915.2h17.23c8.22,0,14.88-3.63,14.88-8.1v-161.64c0-4.47-4.67-8.1-12.89-8.1h-19.22v177.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 894.6,
    y: 820.07,
    width: 41.43,
    height: 7.59,
    transform: "translate(1739.19 -91.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M925.21,813.47h104.42c9.61,0,17.42,7.8,17.42,17.42v29.38c0,9.61-7.8,17.42-17.42,17.42h-104.42c-9.61,0-17.42-7.8-17.42-17.42v-29.38c0-9.61,7.8-17.42,17.42-17.42Z",
    transform: "translate(1822.99 -131.84) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M977.42,915.2h17.23c8.22,0,14.88-2.84,14.88-6.34v-126.57c0-3.5-6.66-6.34-14.88-6.34h-17.23v139.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 974.12,
    y: 781.95,
    width: 4.73,
    height: 20.54,
    transform: "translate(1768.71 -184.27) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 960.27,
    y: 839.89,
    width: 32.44,
    height: 7.59,
    transform: "translate(1820.17 -132.8) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 670.47,
    y: 917.49,
    width: 3.08,
    height: 31.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1042.5,
    y: 917.49,
    width: 3.08,
    height: 31.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M699.23,850.96h212.1c10.4,0,18.84,8.44,18.84,18.84v26.54c0,10.4-8.44,18.84-18.84,18.84h-212.1c-10.4,0-18.84-8.44-18.84-18.84v-26.54c0-10.4,8.44-18.84,18.84-18.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M930.16,883.07v-17.23c0-8.22-5.09-14.88-11.38-14.88h-227.02c-6.28,0-11.38,6.66-11.38,14.88v17.23h249.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 712.12,
    y: 873.73,
    width: 8.48,
    height: 20.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 889.96,
    y: 873.73,
    width: 8.48,
    height: 20.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 772.79,
    y: 880.2,
    width: 58.19,
    height: 7.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 716.36,
    y: 786.74,
    width: 177.84,
    height: 64.22,
    rx: 20.22,
    ry: 20.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M894.2,818.85v-17.23c0-8.22-3.63-14.88-8.1-14.88h-161.64c-4.47,0-8.1,6.66-8.1,14.88v17.23h177.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 734.12,
    y: 809.51,
    width: 6.04,
    height: 20.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1031.99,915.12l-147.13-.09-2.37-65.55h149.5c18.12,0,32.82,14.69,32.82,32.82h0c0,18.12-14.69,32.82-32.82,32.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M916.25,882.3c0,18.12-13.54,32.82-30.23,32.82s-30.23-14.69-30.23-32.82,13.54-32.82,30.23-32.82,30.23,14.69,30.23,32.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M947.42,918.19l-.03-.02c-1.36-1.05-1.62-2.98-.63-4.38,9.96-14.07,12.73-29.05,8.24-44.56-2.5-8.63-6.71-15.21-9.08-18.46-.96-1.32-.75-3.15.47-4.24l.03-.03c1.4-1.25,3.57-1.01,4.68.5,2.67,3.65,7.19,10.76,9.97,20.19,3.6,12.22,4.79,30.65-9.09,50.3-1.05,1.49-3.12,1.82-4.56.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1001.2,918.19l-.03-.02c-1.36-1.05-1.62-2.98-.63-4.38,9.96-14.07,12.73-29.05,8.24-44.56-2.5-8.63-6.71-15.21-9.08-18.46-.96-1.32-.75-3.15.47-4.24l.03-.03c1.4-1.25,3.57-1.01,4.68.5,2.67,3.65,7.19,10.76,9.97,20.19,3.6,12.22,4.79,30.65-9.09,50.3-1.05,1.49-3.12,1.82-4.56.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M911.03,876.44c-1.61-10.34-7.2-15.55-11.6-18.1-6.55-3.79-14.97-4.33-22.52-1.43-7.18,2.76-12.92,9.04-14.98,16.4-1.83,6.55-.47,13.2,3.82,18.75,7.21,9.31,18.27,7.84,23.67,5.51,4.9-2.12,8.57-7.13,9.36-12.77.64-4.57-1.42-8.97-5.39-11.51-3.99-2.55-8.88-2.57-12.78-.05-2.84,1.83-5.66,5.45-2.99,12.29l2.17-.84c-1.71-4.38-1.02-7.49,2.09-9.49,3.12-2.02,7.06-2,10.27.05,3.19,2.03,4.85,5.57,4.34,9.22-.68,4.86-3.81,9.16-7.98,10.96-4.78,2.07-14.57,3.39-20.91-4.79-4.91-6.34-4.57-12.58-3.42-16.7,1.84-6.57,7.16-12.4,13.57-14.86,6.91-2.65,14.58-2.18,20.53,1.27,5.68,3.29,9.3,8.98,10.47,16.45,1.51,9.73-.31,17.49-5.42,23.06-9.6,10.46-29.93,10.31-33.42,10.2,1.27.87,2.6,1.64,3.98,2.3h.18c6.19,0,21.89-1.04,30.97-10.92,5.62-6.12,7.64-14.53,6.01-25Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 865.57,
    y: 809.51,
    width: 6.04,
    height: 20.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 782.15,
    y: 815.98,
    width: 41.43,
    height: 7.59
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.02,
    y: 849.71,
    width: 149.92,
    height: 2.26,
    transform: "translate(-360.49 1103.97) rotate(-62.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 881.12,
    y: 774.67,
    width: 2.26,
    height: 153.78,
    transform: "translate(-295.4 510.02) rotate(-27.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1021.99,
    y: 768.79,
    width: 2.26,
    height: 154.05,
    transform: "translate(-243.55 448.66) rotate(-22.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 955.28,
    y: 731,
    width: 2.26,
    height: 191.61,
    transform: "translate(-220.61 365.33) rotate(-19.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 656.78,
    y: 915.03,
    width: 403.12,
    height: 4.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M373.46,1366.26s307.6,51.05,311.29,48.83c3.69-2.21,43.52-174.09,43.52-174.09,0,0-254.37-45.73-258.49-45.73s-59.44,44.26-60.18,47.21c-.74,2.95-36.15,123.78-36.15,123.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1311.77,1409.93c7.38.74,379.89-7.24,379.89-7.24l-28.03-85.7s-51.64-78.09-78.93-76.66c-27.29,1.42-189.61-24.9-217.63-5.47-28.01,19.43-53.09,3.94-66.37,50.41-13.28,46.47-23.64,51.68-13.29,79.69,10.34,28.01,24.36,44.98,24.36,44.98Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 528.79,
    cy: 1396.86,
    rx: 126.79,
    ry: 126.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 528.79,
    cy: 1396.86,
    rx: 88.22,
    ry: 88.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 528.79,
    cy: 1396.86,
    rx: 59,
    ry: 59.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 1504.99,
    cy: 1396.86,
    rx: 126.79,
    ry: 126.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1504.99,
    cy: 1396.86,
    rx: 88.22,
    ry: 88.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1445.99,1396.86c0,32.59,26.41,59.02,59,59.02s59-26.42,59-59.02-26.41-59.02-59-59.02-59,26.42-59,59.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1796.08,1276.15c-10.72-70.68-45.37-85.53-147.87-106.03-113.11-22.62-256.71-96.39-256.71-96.39,0,0-244.9-119.99-304.9-133.76-60-13.77-207.53-9.83-331.45-8.85-123.93.98-196.71,35.41-259.66,84.59-62.95,49.18-172.12,86.55-172.12,86.55l-19.83,3.54c-20.4,3.64-35.25,21.38-35.25,42.1v175.4c0,19.86,13.38,37.23,32.58,42.3l71.68,18.93h0c5.84,1.01,11.27-3.14,11.91-9.03,7.85-71.76,69.88-126.29,143.85-126.2,78.66.09,143.16,64.73,143.11,143.38,0,8.94-.83,17.68-2.41,26.17-1.63,8.76,5.1,16.83,14.01,16.83h659.65c12.82,0,22.78-11.26,21.08-23.97-.82-6.11-1.25-12.35-1.27-18.68-.24-77.69,62.59-142.1,140.27-143.7,80.52-1.66,146.31,63.12,146.31,143.26,0,5.31-.29,10.54-.85,15.7-1.6,14.6,9.7,27.39,24.39,27.39h94.86c17.25,0,31.23-13.98,31.23-31.23v-91.88c0-12.19-.78-24.37-2.61-36.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M272.47,1168.64h78.13c6.69,0,11.23,6.81,8.64,12.99l-8.78,20.94c-8.37,19.96-27.9,32.95-49.54,32.95h-28.45c-5.57,0-10.08-4.51-10.08-10.08v-46.72c0-5.57,4.51-10.08,10.08-10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1671.81,1201.1c43.02,6.59,92.57,47.33,92.57,47.33,11.84,12.73,2.06,33.39-15.29,32.29l-83.89-5.3c-17.42-1.1-32.28-13.02-37.14-29.79h0c-8.16-28.17-1.22-51.42,43.75-44.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.75,1329.82c-5.38-.13-9.19,5.27-7.21,10.27,5.61,14.14,17.65,25.25,33.03,29.32l80.31,21.22c6.54,1.13,12.62-3.52,13.34-10.12,1.49-13.6,4.73-26.63,9.47-38.92,1.61-4.16-1.42-8.65-5.88-8.76l-123.07-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1649.74,1362.88c-6.1-.15-10.81,5.2-10.03,11.26.87,6.73,1.32,13.58,1.32,20.55,0,5.89-.32,11.7-.95,17.42-1.77,16.2,10.77,30.39,27.06,30.39h105.25c19.14,0,34.65-15.51,34.65-34.65v-27.24c0-7.72-6.16-14.04-13.88-14.23l-143.43-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1391.68,1114.34c-1.4-.77-140.83-77.27-233.3-120.1-91.55-42.4-193.75-37.91-198.15-37.68-11.74-.27-256.25-5.57-331.41,17.86-75.72,23.6-174.34,131.11-178.5,135.68l-1.15,1.26,26.52,124.44,2.84-.16c77.12-4.36,136.17,16.17,170.72,59.36,26.12,32.64,29.35,67.12,29.38,67.46l.25,2.96,278.08,7.15v.02l3.21.06,3.43.09v-.02l387.47,7.56.05-3.33c1.94-125.91,41.74-257.41,42.15-258.72l.79-2.58-2.37-1.3ZM684.88,1358.93c-1.34-9.34-7.2-38.89-30.23-67.81-24.82-31.17-75.05-67.1-173.66-62.27l-24.62-115.54c11.42-12.27,104.71-110.84,174.42-132.57,69.75-21.74,296.29-18.19,326.16-17.62v402.79l-272.07-6.99ZM1344.53,1373.51l-380.94-7.43v-403c17.92-.52,109.42-1.05,192,37.19,85.66,39.68,211.82,108.37,230.55,118.61-5.55,18.99-39.22,138.6-41.61,254.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M261.54,1340.1c5.61,14.14,17.65,25.25,33.03,29.32l80.31,21.22c6.54,1.13,12.62-3.52,13.34-10.12.57-5.25,1.42-10.41,2.5-15.48l-129.19-24.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1640.84,1402.14c-.15,3.35-.4,6.67-.76,9.97-1.77,16.2,10.77,30.39,27.06,30.39h105.25c19.14,0,34.65-15.51,34.65-34.65v-5.71h-166.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1368.71,1402.14c-.02-7.18.49-14.25,1.5-21.17,1.21-8.31-4.99-15.85-13.38-16.05l-686.11-16.75c-7.48-.18-12.88,6.96-10.84,14.16,3.56,12.57,5.47,25.8,5.46,39.45,0,9.05-.84,17.9-2.42,26.49-1.66,8.97,5.11,17.28,14.23,17.28h671.4c13.17,0,23.13-11.65,21.41-24.71-.8-6.12-1.23-12.37-1.25-18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1368.71,1402.14c0-.12,0-.24,0-.35h-703.38c0,9.05-.84,17.9-2.42,26.49-1.66,8.97,5.11,17.28,14.23,17.28h671.4c13.17,0,23.13-11.65,21.41-24.71-.8-6.12-1.23-12.37-1.25-18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M531.46,1126.11l379.18,3.58s23.21-.62,26.37-22.46c3.16-21.84,2.89-115.37,2.89-115.37,0,0-2.75-18.78-20.74-19.02-10.93-.15-102.54-6.69-191.64,4.16-72.68,8.85-139.92,42.05-190.9,93.04l-26.92,26.92s-18.15,28.77,21.76,29.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M982.1,1003.72v98.07c0,12.74,9.77,23.21,22.14,23.71l297.94,11.98c6.84.27,13.54-2.82,17.46-8.59,5.35-7.88,5.97-20.85-20.73-38.23-46.43-30.23-164.55-95.62-208.25-101.95-27.81-4.03-64.2-5.78-86.99-6.52-11.81-.38-21.58,9.37-21.58,21.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M587.64,1080.36s247.07-28.14,252.36-23.26c5.3,4.88,39.63,85.22,45.86,107.19l-291-2.75-20.49-30.9,13.27-50.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1111.48,1102.44s22.74,26.91,29.19,55.95l-7.16,11.63-14.35-15.21-7.68-52.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1135.75,1031.86c-4.35-28.4-30.03-48.83-56.89-35.05-6.04,3.1-14.22,9.39-18.39,14.75-11.28,14.49-14.16,32.38-25.81,46.44,4.28,3.25,9.45,6.65,15.62,9.93l7.26-9.68-2.5,12.08c18.03,8.63,43.49,15.76,78.32,15.56,4.38-19.73,4.72-38.88,2.4-54.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1075.5,1094.35s-25.84-1.64-36.06,9.48c-10.22,11.13,22.67,99.13,24.53,113.29,1.86,14.16-15.25,42.39-15.25,42.39,0,0,71.1,33.27,88.45,21.81,0,0-2.78-113.48-4.64-123.59-1.86-10.11-17.35-51.25-21.06-55.29-3.72-4.05-35.97-8.09-35.97-8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1084.1,1059.88s-.13.76-.37,2.05c-1.15,6.2-5.59,26.78-8.59,32.44-3.62,6.84,12.4,28.64,27.82,25.98,4.59-.79-3.88-20.03-3.47-22.07.78-3.9,1.84-9.22,2.92-14.68.61-3.08,1.23-6.2,1.81-9.13,1.65-8.34,2.99-15.16,2.99-15.16l-23.1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M589.47,1085.1c-.25-1.7-.9-3.29-1.83-4.75l-36.72,36.74s-27.62,43.77,33.11,44.34l16.71.16-11.26-76.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1083.73,1061.93c.24-1.29.37-2.05.37-2.05l23.1-.58s-1.35,6.82-2.99,15.16c-.58,2.92-1.19,6.02-1.8,9.08-3.57-.52-7.29-2.26-11.03-5.52-4.07-3.56-6.74-7.84-8.36-12.41.29-1.46.52-2.72.7-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1099.65,1007.43s-10.89-1.26-17.72,7.56c-6.83,8.82-14.18,36.08,2.77,50.91,16.96,14.82,33.71-1.96,36.19-19.75,2.49-17.79,3.45-39.36-21.25-38.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1125.92,1045.89c-2.02,3.93-5.42,6.1-7.59,4.86-2.17-1.25-2.28-5.44-.26-9.37,2.02-3.93,5.42-6.11,7.59-4.86,2.17,1.24,2.28,5.44.26,9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1100.87,1004.52s-14.55,25.93-24.96,27.13c-10.41,1.2-11.77,14.98-11.77,14.98,0,0,3.72-31.75,14.03-37.87,10.3-6.12,22.71-4.23,22.71-4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1078.64,1038.16c.85,4.6-.86,8.83-3.8,9.43-2.95.61-6.02-2.64-6.87-7.24-.85-4.6.86-8.83,3.8-9.43,2.95-.6,6.02,2.64,6.87,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1042.04,1220.25c-.06-.24,9.73-41.84,13.69-51.03,3.96-9.2,19.33-51.91,19.33-51.91l-19.9-4.35s-12.83,33.43-18.69,48.54c-5.85,15.11-3.35,42.97-3.61,50.84,0,.11-.86,6.65-.86,6.76h0c-.2.87-.38,1.6-.47,1.74-.24.38-.92,3.02-.95,3.25-.03.23-.62,1.12-.85,1.5-.24.38-.78,5.73-.9,6.59-.12.86.26,2.81.26,2.81l-.21,3.58c-.15,2.63,2.57,1.93,2.57,1.93-.06,1.24.37,1.89,1.06,2.12.7.23,1.52.03,1.65.09.13.05.18.44.18.44-.07.79.82,1.4,1.39,1.51.57.11,1.6-.27,1.89-.61.29-.34.49-.29.49-.29.58.5,2.8.47,3.32-.24.51-.72.98-4.5,1.21-4.83.23-.34.73-.92.8-1.47.07-.55,1.89-4.42,2-5.19.1-.77-1.02-3.38-1.27-4.94-.25-1.56-1.77-3.99-2.14-4.69-.14-.27-.1-1.17,0-2.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1107.77,1054.77l-16.72-.87s.06,6.37,7.4,6.97c8.95.72,9.32-6.1,9.32-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1016.24,1067.54l-6.05,40.01s22.09,47.64,35.28,43.51c11.07-3.47,4.26-45.62,4.26-45.62,0,0-6.03-22.64-4.22-33.97,1.81-11.33-29.27-3.93-29.27-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1045.51,1071.47c1.81-11.33-29.27-3.93-29.27-3.93l-.5,3.32c.91,2.22,2.02,4.12,3.37,5.58,6.94,7.5,17.79,12,27.17,12.34-.94-6.11-1.52-12.65-.77-17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1011.14,1010.93c-.88-.32-7.04,45.57,4.65,58.2,11.69,12.63,34.48,16.76,42.65,6.81,9.04-11,8.59-60.32-9.6-73.31-18.18-12.99-37.71,8.3-37.71,8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1041.93,978.08c-14.05,2.88-23.16,11.49-26.5,15.17-6.38.76-15.05,4.29-24.01,19.17-11.01,18.29-2.88,38.56,9.94,48.51,12.82,9.94,12.64,21.43,12.64,21.43l2.03-5.94c1.5-4.5,2.11-9.27,1.61-13.99-.3-2.83-.9-5.9-2.07-8.41-3.08-6.64,6.62-11.05,9.34-16.58,2.1-4.25,2.2-13.99,5.5-21.02l3.94-5.37s9.1-7.1,18-5.1c8.9,2,7.62-31.55-10.41-27.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1024.31,1045.6c.09,5.6-2.44,10.18-5.67,10.24-3.22.05-5.91-4.44-6-10.04-.09-5.6,2.44-10.18,5.67-10.24,3.22-.06,5.91,4.44,6,10.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1043.3,1058.54l17.63-.92s-.06,6.74-7.8,7.37c-9.44.77-9.83-6.45-9.83-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1005.2,1105.95h0c1.62-3.02,4.63-5.05,8.05-5.35,14.81-1.33,55.51-1.35,76.29,34.62,3.28,5.67,5.63,11.83,7.32,18.15l4.37,18.02-107.11-3.48.18-11.9c-1.09-17.37,2.69-34.71,10.9-50.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1259.62,1177.96l15.55-63.15c1.04-4.23-1.54-8.5-5.77-9.55-4.23-1.04-8.5,1.54-9.55,5.77l-16.3,66.2,16.07.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1219.44,1176.14c4.4-2.75,7.97-5.01,10.38-6.47.18-.11,11.39-5.49,11.57-5.59h0c1.58-.58,2.92-1.04,3.23-1.04.85-.02,5.72-1.66,6.11-1.84.39-.18,2.4-.18,3.25-.2.85-.02,9.85-4.66,11.33-5.37,1.49-.7,4.17-3.32,4.17-3.32l5.87-3.36c4.31-2.46.41-6.06.41-6.06,2.03-1.17,2.61-2.53,2.26-3.87-.35-1.34-1.52-2.44-1.57-2.7-.05-.26.51-.74.51-.74,1.32-.7,1.36-2.73.95-3.75-.41-1.03-2.07-2.25-2.91-2.36-.84-.1-.97-.48-.97-.48.18-1.43-2.14-4.92-3.8-5-1.66-.07-8.11,3.08-8.88,3.06-.77-.02-2.2-.2-3.14.24-.94.44-8.93,1.55-10.26,2.18-1.33.63-4.28,5.09-6.49,7.1-2.21,2-4.48,6.91-5.2,8.21-.28.51-1.73,1.36-3.39,2.22h0c-.26.27-49.1,17.91-78,26.54l64.58,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1067.18,1170.02c-3.02-18.17-6.76-37.26-10.76-46.08-8.78-19.33-38.42-30.85-52.95-18.83-7.76,6.41-4.41,36.94,2.19,63.29l61.51,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M636.72,1064.83s-36.29-.9-48.62,7.26c-12.33,8.16-10.82,89.31-10.82,89.31l11.97,2.27s4.34,55.84,13.61,58.76c9.27,2.91,70.22-15.78,82.88-31.5,12.66-15.72-26.82-131.5-26.82-131.5l-22.21,5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M701.24,1000.47c3.16-9.81,5.28-39.42,5.97-49.48-.49-.72-3.13-5.05-2.85-13.47.2-5.96-3.96-15.82-.15-15.15,3.82.67,4.02,11.01,6.31,9.23,2.29-1.78,3.34-23.42,6.8-22.82,3.46.6,1.11,20.99,3.16,19.39,2.05-1.59,2.14-20.39,7.03-19.53,4.89.85-2.16,22.11.47,22.56,2.63.46,6.72-13.05,10.66-12.36,3.94.69-6.47,18.19-5.27,17.25,1.21-.94,9.59-8.09,10.99-6.49,1.58,1.81-17.84,22.27-17.9,27.65h0c1.62,13.64,4.84,38.35.44,53.88-5.38,19-19.18,61.22-19.18,61.22l-29.4-6.99s19.17-53.26,22.92-64.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M713.76,935.59c1.44.65,2.65,1.65,3.7,2.79.11.23,3.78,3.69,2.85,9.32-.65-3.45-1.38-7.27-6.54-12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M525.73,1080.73s.75-4.73-3.18-12.04c-2.52-4.69-3.28-14.24-5.92-12.18-2.64,2.05,1.33,10.41-1.13,9.9-2.45-.51-11.87-17.41-14.26-15.55-2.39,1.86,7.51,17.24,5.32,16.78-2.19-.46-9.75-15.47-13.13-12.83-3.38,2.63,10.45,16.83,8.63,18.24-1.81,1.41-10.31-7.77-13.03-5.65-2.72,2.12,12.17,11.98,10.88,11.71-1.29-.27-10.52-2.65-10.94-.81-.48,2.07,18.79,8.15,20.98,12.43,2.19,4.28,35.33,47.01,44.79,47.03,9.47.02,51.98-28.75,55.07-38.11,3.09-9.36-.76-19.28-6.96-20.57-6.2-1.29-45.83,27.24-47.78,26.84-1.95-.41-29.34-25.19-29.34-25.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M515.89,1070.37c-.93,1.28-1.49,2.74-1.83,4.25.01.26-1.46,5.08,2.13,9.51-1.14-3.32-2.39-7-.3-13.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M615.3,1139.71s38.17,30.35,42.39,36.54c3.16,4.63-7.33,56.83-7.33,56.83,0,0-15.09.47-22-4.89,0,0,4.13-36.08,2.31-37.49-1.81-1.41-43.7-20.04-43.7-20.04l2.65-21.4,25.68-9.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M688.53,1030.5s6.6,1.23,29.18,25.88l-26.25,53.39-24.27-44.39,21.33-34.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M645.95,1068.15s17.25-3.85,23.29-6.81c6.05-2.96,61.95,128.76,47.86,133.41-29.44,9.71-105.88,35.39-105.88,35.39,0,0-2.2-7.63.57-21.53,4.81-24.06,3.22-77.75,2.21-87.14-.59-5.52-33.21,10.45-33.21,10.45l-12.85-41.63s37.23-12.68,49.72-16.69c3.49-1.12,28.29-5.45,28.29-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M709.74,1149.7c-6.98-21.73-53.21-84.22-53.62-84.81l7.55-5.15c1.69,2.47,39.36,55.45,46.74,78.43l-.68,11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M609.47,1190.03l-4.79-6.07c.32-.26,32.5-26.03,33.37-54.59.88-28.86-22.38-56.58-22.62-56.86l5.89-5.02c1.04,1.22,25.43,30.23,24.46,62.11-.98,32.19-34.87,59.29-36.31,60.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M637.69,980.07s13.65-10.14,26.58,6.32c10.32,13.13,8.95,9,14.05,15.52,5.1,6.53,12.79,7.09,13.96,17.95,1.17,10.86-3.72,13.09-3.72,13.09,0,0,5.49,7.95,1.36,17.18-4.13,9.23-15.96,18.07-26.66,18,0,0-14.94,10.41-31.31,8.02-16.36-2.4-10.82-3-17.33-2.29-6.51.7-25.09-6.33-23.59-19.67,0,0-12.1-11.59-2.81-23.13,9.29-11.53,14.32-19.57,18.85-34.21,4.53-14.64,23.02-19.37,30.62-16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M655.96,1055.02s1.49,19.28,3.49,20.89c2,1.61,4.84,4.33,2.68,9.2-2.16,4.87-14,3.18-19.65,1.14-5.42-1.96-9.25-6.29-9.25-6.29l-.59-30.72,23.32,5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M649.15,1063.8c-3.84-.9-10.57-2.7-16.43-10.27l-.08-4.3,23.32,5.79s.36,4.7.97,9.66c-3.16.21-5.94-.44-7.77-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M623.27,1032.38s-1.76-11.24-8.46-8.3c-6.7,2.94.42,19.42,6.11,18.24,5.69-1.18,2.35-9.94,2.35-9.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M644.18,988.68s10.83-1.41,17.29,6.44c6.46,7.85,15.08,31.32,7.71,48.96-7.38,17.63-19.52,14.79-24.52,13.62-5.01-1.17-14.94-3.88-21.44-18.93-6.5-15.04-6.77-50.4,20.97-50.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "865.56 1168.36 885.51 1263.66 851.09 1260.32 834.52 1173.16 865.56 1168.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M871.47,1171.16l-36.95,2s-2.75-25.51-3.38-37.72c-.76-14.81-.49-33.94,1.32-33.62,5.08.89,11.98,3.31,16.29,8.64,14.91,18.41,22.73,60.7,22.73,60.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M847.18,1132.1c.89,4.48,24.29,129.02,24.29,129.02-55.41,30.38-97.7,4.46-97.7,4.46,0,0,2.11-83.73-.73-95.34-1.88-7.69-8.69-58.29-3.74-60,6.36-2.19,15.97-5.41,23.99-6.66,6.85-1.07,33.57-2.87,38.44-1.51,0,0,11.7,11.18,15.43,30.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M827.32,1013.28s22.41-.34,20.56,18.22c0,0,16.67,6.48,5.56,21.51,0,0,11.86,16.16-8.78,31.67,0,0-5.48,21.7-28.85,11.33,0,0-6.91,5.16-16.47-1.74-9.56-6.9-10.81-10.99-10.81-10.99,0,0-21.15-4.01-18.24-23.46,0,0-11.11-9.47,5.67-21.37,0,0-.31-26.68,22.36-23.08,0,0,13.24-20.36,29.01-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M792.22,1056.96c-.61,4.73-3.69,8.24-6.89,7.83-3.2-.41-5.3-4.58-4.69-9.31.61-4.73,3.69-8.24,6.89-7.83,3.2.41,5.3,4.58,4.69,9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M844.83,1071.42c-1.97,4.35-5.94,6.8-8.88,5.47-2.94-1.33-3.73-5.93-1.76-10.28,1.97-4.35,5.94-6.8,8.88-5.47,2.94,1.33,3.73,5.93,1.76,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M817.83,1085.86c-.03.34,1.87,12.53,2.89,18.97.38,2.4-1,4.73-3.28,5.58-6.1,2.26-17.98,5.16-25.46-2.7-.68-.72-1-1.7-.9-2.69l3.1-28.53,23.66,9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M819.67,1098.14c-6.48,2.68-25.2.36-26.61-11.43l1.11-10.22,23.66,9.37c-.01.16,1.27,8.56,1.84,12.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M823.88,1027.75s-9.86-2.14-19.28,3.71c-9.42,5.85-24.71,28.85-11.93,48.85,12.78,19.99,34.5,10.2,42.14-5.63,7.64-15.84,10.9-39.41-10.93-46.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M817.78,1077.23l-13.12-.75s.02,5,5.78,5.5c7.02.61,7.34-4.74,7.34-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M840.71,1038.96s-9.56-5.12-16.67-4.45c-7.12.67-30.31,17.54-33.69,14.71-3.37-2.82.98-17.74,3.67-19.9,2.69-2.16,13.44-8.67,14.36-8.79.92-.12,10.67.06,12.34.49,1.67.43,13.73,6.19,13.73,6.19l6.25,11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M701.88,1272.43c.2-.57.7-.6,1.2-.63,4.89-.3,9.78-.68,14.61-1.56.81-.15,1.6-.35,2.33-.68,1.33-.58,2.67-.61,4.04-.28.74.18,1.5.2,2.26.17,2.46-.09,9.41-2.7,13-3.44.82-.17,1.45-.81,1.63-1.63,3.11-14.15,9.73-45.88,10.39-56.27.85-13.28,8.11-73.28,8.11-73.28l24.68,6.05s-8.68,44.39-10.8,65.85c-1.63,16.57-17.02,52.11-21.88,62.34-2.29,7.58-7.95,7.96-9.26,8.16-.75.11-1.43.51-1.91,1.1-.86,1.07-1.85,2.01-3,2.78-.85.57-1.5,1.31-2.04,2.16-.99,1.55-1.87,3.16-2.74,4.78-.58,1.07-1.2,1.43-2.12,1.21-.98-.24-1.46-.94-1.48-2.12-.03-1.75.48-3.35,1.31-4.87.78-1.42.69-2.23-.31-3.49-.57-.72-1.16-1.42-1.9-1.98-.75-.57-1.54-1-2.53-.83-1.74.49-3.51.91-5.31,1.16l-1.47.35c-.05,0-.8.2-.8.2-.12.04-2.72.4-3.61.43-.72.02-1.87.11-2.86.19-.89.07-2.79-.34-2.86-.34-.87,0-1.65-.28-2.31-.84-.27-.23-.54-.49-.41-.9.11-.38.4-.54.78-.62.58-.12,3.61-.59,3.57-.72-.9.03-3.73.05-4.63.06-1.22,0-2.28-.4-3.15-1.27-.34-.34-.74-.68-.53-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M742.98,1170.95l35.76,17.29s5.61-26.26,9.8-42.49c3.6-13.96-14.22-38.79-20.15-35.39-13.28,7.6-25.41,60.6-25.41,60.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M984.64,1124.68l317.97,13.53s-27.73,92.79-28.41,97.42c-.68,4.63-105.03,61.57-131.25,60.89-26.22-.68-87.37-22.63-100.53-26.5-13.16-3.87-47.34-30.53-45.29-46.94,2.05-16.41-12.49-98.4-12.49-98.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M990.83,1156.75h85.32c2.11,0,3.81,1.71,3.81,3.81v7.37c0,2.11-1.71,3.81-3.81,3.81h-85.32c-2.11,0-3.81-1.71-3.81-3.81v-7.37c0-2.1,1.71-3.81,3.81-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1318.45,1108.07l-336.35-28.79v22.51c0,12.74,9.77,23.21,22.14,23.71l297.94,11.98c6.84.27,13.54-2.82,17.46-8.59,3.37-4.97,4.85-11.96-1.19-20.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "982.1 1079.28 982.1 1076.05 1317.25 1106.41 1318.45 1108.07 982.1 1079.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1059.55 1127.71 1090.2 1128.95 1115.37 1090.69 1085.58 1088.14 1059.55 1127.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1113.94 1129.9 1138.43 1092.66 1127.11 1091.69 1102.28 1129.43 1113.94 1129.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M526.45,1125.89l384.19,3.8,3.44,121.76s-44.88,65.28-50.3,64.6c-5.41-.68-120.16-19.14-130.46-18.46-10.3.68-100.25-43.46-104.49-42.58-4.24.88-32.27-14.16-32.27-14.16l-45.68-32.27-45.29-46.61,20.87-36.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.91,1149.25h85.32c2.11,0,3.81,1.71,3.81,3.81v7.37c0,2.1-1.71,3.81-3.81,3.81h-85.32c-2.11,0-3.81-1.71-3.81-3.81v-7.37c0-2.11,1.71-3.81,3.81-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M661.06,1037.58l-13.3,2.56s1.28,4.99,7.16,4.04c7.17-1.17,6.14-6.59,6.14-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M619.88,1024.84s30.01-13.75,32.98-35.29c2.97-21.53-24.67-.97-24.67-.97l-11.18,10.73,2.86,25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M993.02,1121.96s5.58,3.85,12.65,3.59c0,0-9.4,2.87-9.67,2.64-.28-.23-5.01-4.03-4.94-4.11.08-.08,1.96-2.12,1.96-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1021.99,982.89l37.56,2.38s-6.15-10.18-8.76-10.18h-19.79l-9.01,7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3129.78,1543.13H136.76c-6.27,0-11.36-5.09-11.36-11.36h0c0-6.27,5.09-11.36,11.36-11.36h2993.03c6.28,0,11.36,5.09,11.36,11.36h0c0,6.27-5.09,11.36-11.36,11.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2299.18,873.66c15.5,4.15,18.08,63.88,18.08,63.88l49.12-5.63s-8.95-62.29-34.9-88.32c-25.94-26.03-91.51-10.12-116.43,6.09-24.93,16.21-14.11,36.85-14.11,36.85,0,0,82.74-17.01,98.24-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M2348.55,923.39c2.57,56.73,18.47,61.76,18.79,62.55.33.06,13.03,9.83,27.09-3.09l-4.67-4.74c-2.01,2.05-5.07,3.9-8,4.72-6.53,1.7-10.76-1.55-11.27-1.71-.34-.28-3.68-2.29-5.35-5.05-8.16-10.91-12.05-39.26-13.15-52.8l-3.43.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2183.42,881.92s6.89,27.03,7.68,49.01c.79,21.97,15.93,40.3,17.9,95.29,1.97,54.99,9.83,105.54,9.83,105.54,0,0,61.02,4.25,73.03-8.7,12.01-12.95,6.81-130.66-5.07-187.89-11.88-57.23,40.35-72.83,13.21-91.58-27.13-18.75-62.42-6.04-77.36-.95-14.94,5.09-39.65,27.17-39.21,39.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M2284.18,927.41s7.2,43.91,1.79,88.37c-5.42,44.47,3.21,132.2,3.21,132.2,0,0,45.45,31.73,58.81,6.54,2.51-4.73,8.51-60.93,9.05-84.43.57-24.96-2.86-112.12-4.02-140.37-.24-5.92-2-11.68-5.09-16.73-9.93-16.22-32.73-52.13-40.66-53.37-10.35-1.62-28.52,20.75-23.08,67.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2354.2,960.05c-6.39,6.23-47.02,45.31-67.41,48.13.24-2.49.45-4.96.62-7.42,15.95-2.56,51.88-35.67,66.44-49.79.11,2.89.23,5.93.35,9.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2284.29,1065.06c-.04-2.44-.08-4.87-.09-7.29,12.32,5.28,55.68,1.91,72.87,0,.02,2.54.03,4.88.02,6.99-15.76,1.75-58.11,6.39-72.8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2352.97,1121.83c-.25,2.3-.51,4.55-.76,6.72-17.13,3.43-50.13-11.2-65.97-18.07-.17-2.6-.33-5.27-.48-8.02,14.73,6.4,52.16,22.2,67.22,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2353.97,1112.31c-7.61,3.19-55,23.52-65.82,24.21-.17-2-.35-4.23-.54-6.66,7.63-.71,43.7-15.79,67.12-25.56-.24,2.67-.5,5.34-.77,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M2292.42,1023.1h15.21c5.48,0,9.93,4.45,9.93,9.93v89.18c0,5.48-4.45,9.93-9.93,9.93h-15.21c-5.48,0-9.93-4.45-9.93-9.93v-89.18c0-5.48,4.45-9.93,9.93-9.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2282.49,
    y: 1055.57,
    width: 35.07,
    height: 7.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2310.56,1439.14s16.24,14.91,16.28,14.94c2.28,1.68,8.38,5.37,10.15,7.19,6.66,6.84-36,23.91-32.15,14.21.35-.88,1-8.6-1.06-11.13-3.18-3.89-8.9-9.44-8.9-9.44l15.67-15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2304.86,1475.36s9.16-4.88,13.32-7.93c4.16-3.05,4.68-12.17,8.42-13.51,4.12-1.47,21.41,16.21,21.41,16.21,0,0-33.8,36.73-51.49,48.98-3.81,2.64-8.43,1.8-10.06,1.83-6.25.11,8.57-26.44,18.4-45.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2106,1468.06s-5.04,24.42-5.05,24.47c-.31,3.19-.36,11.26-1.1,14.04-2.78,10.43-43.89-21.24-32.3-23.09,1.05-.17,6.27-2.26,8.06-5.48,3.12-5.6,6.08-16.08,6.08-16.08l24.3,6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2067.7,1483.41s10.01,6.1,15.36,8.39c5.35,2.29,15.13-4.06,18.59-1.19,3.8,3.16-2.39,31.12-2.39,31.12,0,0-70.34-18.65-85.3-28.33-5.93-3.83,29.57-8.51,53.74-9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M2143.85,1133.06l-43.59,174.23-27.56,168.73,34.31,4.63s48.33-129.03,49.68-143.88c1.35-14.85,25.61-84.27,25.61-84.27l-38.46-119.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2245.58,1112.89s-3.26,167.06-.57,182.58c2.69,15.53,75.72,147.98,75.72,147.98l-24.58,26.72s-104.48-121.14-109.09-131.83c-7.22-16.75-42.86-205.63-42.86-205.63l101.39-19.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1964.83,844.43c3.52,7.05,3.97,10.5,4.87,11.8,1.06,1.54,24.02,11.31,24.02,11.31,0,0,67.49,29.25,71.18,30.71l75.42-.56,11.84,37.13s-82.12-1.56-86.42-2.39c-4.3-.83-91.15-50.82-98.93-54.98,0,0-11.04-1.6-17.95-2.83-6.91-1.23-11.84-3.47-13.36-4.78-2.96-2.55-.84-5.66-.54-6.7-2.13-4.47,1.24-5.91,1.33-6.08.2-.37-.85-1.32-.46-3.52.33-1.9,2-2.23,2.58-3.23-1.29-4.79,2.54-5.12,3.88-4.88s12.42,2.74,13.73,3.04c1.73.4,2.07.14,2.35-1.04.77-3.21-.92-8.54-.75-10.79.22-3.04,2.62-4.6,3.46-4.21.75.35.88,6.23,3.75,11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2124.72,937.54c-5.07-18.43-9.35-35.54-8.5-44.05,0,0,22.5-3.75,49.33-7.8,19.25-2.91,49.95,28.12,43.97,35.14-13.38,15.71-84.8,16.71-84.8,16.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2205.54,881.71s18.51-1.7,25.91,15.85c7.4,17.55,14.8,101.93,11.44,142.43-3.36,40.5,10.83,96.55,10.83,96.55-64.53,33.4-110.4-2.73-110.4-2.73,0,0-17.04-154.98-10.76-183.6,13.12-59.82,38.33-69.47,38.33-69.47l34.66.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2256.81,1160.81c6.99-11.4,8.56-9.78,9.42-11.26,1.01-1.76-.11-28.88-.11-28.88,0,0-2.8-79.97-3.1-84.28l-35.8-73.83,30.94-28.98s36.84,81.4,38.04,86.01c1.2,4.61-7.33,113.29-7.77,122.88,0,0,3.59,11.6,5.61,18.96,2.02,7.36.72,15.3.98,17.46.04.32.48,7.58-1.31,16.7-1.54,7.86-3.59-.28-3.59-.28,0,0,.3-15.06-.86-14.86-.9.15-.59,8.37-2.2,17.09-.42,2.24-.83,4.45-1.23,6.48-1.05,5.32-4.53,6.21-4.3.48.08-2.03.3-5.39.78-7.77.52-2.57.2-5.09.32-7.32.24-4.42.46-7.64.28-7.54-.24.12-.8-.79-1.31,1.58-.62,2.84-.62,9.16-1.85,13.28-.69,2.33-1.85,7.29-1.85,7.29,0,0-3.12,7.18-3.59,7.13-2.54-.22-1.76-5.72-.41-8.77-.11-2.38,1.25-7.56,1.25-7.56,0,0,.47-11.09-1.07-11.17-.65-.03-1.73,6.74-3.81,13.23-1.93,6.02-4.84,11.79-6.05,11.59-2.06-.33-.62-7.25-.62-7.25,0,0,1.27-4.79,1.57-6.41.35-1.9.99-7.67.99-7.67,0,0,1.3-20.19-.15-20.13-1.46.06-5.16,1.73-5.66,2.95-.5,1.23-.28,3.96-.78,5.19-.5,1.23-2.19,2.4-3.7,1.9-1.51-.5-1.29-7.36-1.29-7.36,0,0,.22-5.58,2.24-8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2273.4,955.18l-40.56,31.46s-17.91-17.08-26.91-35.97c-9.11-19.12,1.98-69.51,11.68-66.92,21.68,5.8,55.8,71.42,55.8,71.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2197.8,844.23l6.07,40.01s-22.17,47.63-35.4,43.5c-11.1-3.47-4.27-45.61-4.27-45.61,0,0,6.05-22.63,4.24-33.96-1.82-11.33,29.36-3.93,29.36-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2168.43,848.17c-1.82-11.33,29.36-3.93,29.36-3.93l.5,3.32c-.91,2.22-2.03,4.12-3.38,5.58-6.96,7.5-17.85,12-27.26,12.34.94-6.11,1.52-12.65.78-17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2202.91,787.64c.88-.32,7.06,45.56-4.67,58.19-11.73,12.63-34.59,16.76-42.79,6.81-9.07-11-8.61-60.31,9.63-73.3,18.24-12.99,37.83,8.3,37.83,8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2172.02,754.79c14.1,2.87,23.23,11.49,26.59,15.16,6.4.76,15.1,4.29,24.09,19.17,11.05,18.29,2.89,38.56-9.97,48.5-12.86,9.94-12.68,21.43-12.68,21.43l-2.03-5.94c-1.5-4.5-2.11-9.27-1.61-13.99.3-2.83.91-5.9,2.08-8.41,3.09-6.64-6.64-11.05-9.37-16.58-2.1-4.25-2.2-13.99-5.52-21.02l-3.96-5.37s-9.13-7.1-18.06-5.1c-8.93,2-7.64-31.55,10.45-27.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2189.71,822.3c-.09,5.6,2.45,10.18,5.68,10.24,3.23.06,5.93-4.44,6.02-10.04.09-5.6-2.45-10.18-5.68-10.24-3.23-.06-5.93,4.44-6.02,10.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2182.39,966.53c-.85-34.86,1.32-82.77,34.56-96.36,11.88-4.98,26.39.62,37.39,4.71h0c-13.5-1.89-26.23,3.32-32.81,7-27.36,13.84-27.15,53.47-26.16,84.34,2.49,77.62,61.97,69.39,61.97,69.39l1.39,5.17s-22.34,7.33-50.85-6.73c-22.73-11.22-25.49-67.53-25.49-67.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2608.49,992.93l-10.41,46.02c-21-8.24-54.24-13.27-66.58-18.59-14.45-8.36-23.96-8.68-28.46-8.39-2.42.16-12.52,1.36-12.52,1.36l1.17,3.31s6.62-.24,7.59-.15c2.41.24,1.17.82,1.17.82-2.07.1-11.05,1.99-11.05,1.99,0,0,1.89,2.95,4.46,2.58,4.52-.66,7.37.27,5.78.72-1.16.32-2.83-.31-5.54.08-6.6.95-7,4.56-.83,4.22,2.7-.15,7.57,1.55,10.65,2.6-1.01.73-2.21,1.23-2.8,1.44-1.09.4-9.32.61-8.79,2.58.52,1.98,18.99,2.34,18.99,2.34l9.49-1.31.51.14h0s79.82,38.04,92.41,34.04c14.48-8.64,21.09-75.4,20.36-77.28l-25.62,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2636.21,948.64s-22.93-17.82-35.05,70.8l41.42,11.55,15.8-33.3-22.18-49.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2610.02,872.57c4.7-30.62,32.39-52.63,61.36-37.77,6.52,3.34,15.34,10.12,19.84,15.9,12.37,15.88,15.37,35.57,28.49,50.84,11.31,13.17,41.5,10.68,55.59,20.81,14.1,10.13,23.98,28.29,23.98,50.01,0,24.29-5.48,50.08-24.31,65.43-18.82,15.36-45.57,19.18-68.97,12.68-23.4-6.51-43.48-22.45-57.94-41.98-14.45-19.52-24.67-40.93-31.87-64.13-8.04-25.89-9.21-52-6.17-71.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M2620.52,961.01c15.1-33.65,65.52-37.44,97.58-19.18,9.53,5.43,11.22,5.03,17.2,11.01,15.67,15.67,30.78,173.91-9.25,186.22-46.71,14.37-88.45,5.5-104.21-19.26-10.56-16.58-24.56-107-1.32-158.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2617.95,1459.87s-2.44,26.6-.83,35.27c.21,1.16.69,2.63,1.24,4.25,1.65,4.86-2.87,19.71-2.87,19.71l-60.61.22c-3.3.01-1.09-2.08,1.59-4,4.4-3.14,7.94-5.21,21.94-11.76.91-.43,4.24-2.48,5.44-3.19,3.04-1.8,6.11-4.67,8.76-7.54,4.41-4.78,5.08-28.22,5.08-28.22l20.26-4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M2583.85,1500.37c15.98,4.3,27.86,1.66,34.52-.93,1.65,4.85,4.75,21.27,2.9,21.27-15.2,0-28.06,2.88-71.62,2.19-1.56-.02-1.37-5.38-.35-6.56,2.81-3.27,33.35-15.26,34.55-15.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2693.97,1144.11s-.86,37.97-11.74,62.28c-10.6,23.68-61.32,82.09-74.8,116.18,4.17,19.23,15.62,46.25,14.79,67.57-.94,24.15.47,88.06.47,88.06l-27.22.86-35.71-164.91,53.81-177.93,24.42-43.21,55.99,51.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2810.26,1422.05s16.72,22.95,24.09,28.75c3.95,3.11,14.66,7.28,15.79,12.42,1.13,5.14-48.52,50.59-48.52,50.59-2.63,2.33-2.33-.89-1.54-4.31,1.3-5.6,2.68-9.73,9.27-24.79.43-.98,1.65-4.96,2.11-6.37,1.16-3.58,1.61-8.02,1.71-12.17.17-6.91-15.75-26.11-15.75-26.11l12.85-18.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M2811.46,1478.33c15.78-7.78,23.41-18.23,26.92-24.97,4.72,2.72,17.43,8.52,16.32,10.14-8.78,12.74-17.9,28.59-53.16,58.61-1.26,1.07-6.44-5.12-6.45-6.78-.05-4.58,15.92-35.59,16.38-37.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2692.05,1119.8s21.05,31.61,26.06,57.78c4.88,25.48-3.23,102.41,5.25,138.08,14.43,13.37,39.3,28.96,50.83,46.9,13.07,20.33,50.83,71.91,50.83,71.91l-21.82,16.3-123.74-114.71-50.1-153.04-17.19-44.75,79.88-18.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2675.01,939.92s27.87-1.77,38.89,10.22c11.02,11.99-24.45,106.85-26.46,122.11-2,15.26,16.45,45.69,16.45,45.69,0,0-76.69,35.86-95.4,23.5,0,0,3-122.31,5-133.21,2-10.9,18.71-55.24,22.72-59.6,4.01-4.36,38.8-8.72,38.8-8.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2665.73,902.76s.14.82.4,2.21c1.24,6.69,6.03,28.87,9.26,34.96,3.91,7.37-13.37,30.87-30,28-4.95-.85,4.18-21.59,3.75-23.79-.84-4.21-1.98-9.94-3.15-15.82-.66-3.32-1.32-6.68-1.95-9.85-1.78-8.99-3.23-16.34-3.23-16.34l24.92.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2666.14,904.98c-.26-1.39-.4-2.21-.4-2.21l-24.92-.62s1.45,7.35,3.23,16.34c.62,3.14,1.28,6.49,1.94,9.79,3.85-.57,7.87-2.43,11.9-5.95,4.39-3.84,7.27-8.45,9.01-13.38-.31-1.57-.56-2.93-.76-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2646.81,849.11s11.75-1.35,19.11,8.15c7.36,9.5,15.3,38.89-2.99,54.87-18.29,15.98-36.36-2.11-39.04-21.28-2.68-19.18-3.72-42.43,22.92-41.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2645.5,845.97s15.69,27.95,26.92,29.24c11.23,1.29,12.7,16.14,12.7,16.14,0,0-4.01-34.22-15.13-40.82-11.11-6.6-24.49-4.56-24.49-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2669.47,882.23c-.91,4.96.92,9.51,4.1,10.17,3.18.65,6.49-2.84,7.41-7.81.91-4.96-.92-9.51-4.1-10.17-3.18-.65-6.49,2.84-7.41,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2680.02,932.61c-17.35,23.21-25.27,60.05-13.56,95.56,4.82,14.03,10.27,27.63,20.65,41.66,13.08,17.43,23.35,22,22.45,21.48l3.85-7.49c-.06-.05-5.14-2.74-11.43-9.13-.36-.46-14.46-13.48-24.09-39.29-22.58-57.37,9.09-93.81,9.62-95.17.22-.3.43-1.29.58-1.46l-8.07-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2610.38,1074.32c5.21-69.46,34.04-128.95,34.36-129.33l-7.85-.64c-.36.43-8.8,5.05-16.83,24.28-6.62,15.88-14.09,40.83-14.21,72.69-.02,6.6,4.53,32.99,4.53,32.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "2585.42 1095.06 2483.08 1071.57 2483.08 988.31 2585.42 1011.79 2585.42 1095.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2488.9,1023.71c9.38,1.38,5.47-2.15-.67-5.52,4.02,1.34,4.74.47,4.63-.67-.13-1.38-7.77-6.45-9.8-6.19-1.87.24-1.76,6.71-1.18,8.6.09,1.12.23,2.39.2,3.76-.09,3.86-.06,4.63.23,6.14.45,2.32,2.73,2.3,5.89,3,4.39.5,5.29-2.13-.76-4.45.63.09,6.34,1.12,6.97-.27.6-1.33-1.38-2.35-5.52-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2674.13,999.41l-2.72,50.77c-21-8.24-54.67-18.43-67.01-23.74-14.45-8.36-23.96-8.68-28.46-8.39-2.42.16-12.52,1.36-12.52,1.36,0,0-10.42,6.58-9.78,7.13,1.88,1.58,10.95-3.82,10.95-3.82,0,0,6.62-.24,7.59-.15,2.41.24,1.17.82,1.17.82-6.58.69-11.05,1.99-11.05,1.99,0,0-12.34,4.64-11.86,5.37.69,1.04,1.85.95,6.47-.07,2.83-.62,7.62-2.14,10.19-2.52,4.52-.66,7.54.54,6,.62-1.2.07-4.11.29-6.83.68-6.6.95-14.17,3-13.28,3.9,1.19,1.21,10.29-.24,13.56-.5,2.7-.15,10.33,2.21,10.25,2.71-.13.38-4.12.52-5.04.5-1.16-.02-7.4-.47-7.4.83,0,1.46,19.48,4,19.48,4l9.85-.28.51.14h0s75.17,45.65,92.36,38.95c14.48-8.64,21.15-80.3,20.41-82.19l-32.88,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2714.83,947.48c7.01,16.77-1.67,64.02-1.67,64.02,0,0-37.43-5.35-45.22-10.21,0,0,10.5-45.04,11.24-47.81,3.37-12.54,12.33-15.25,18.37-16.41,9.5-1.83,17.27,10.41,17.27,10.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.8f4064082f3a1f93db67e73546699f48.svg";
export { ForwardRef as ReactComponent };